document.addEventListener("DOMContentLoaded", async () => {
	const { loadMoreItems } = await import("@utils/loadMoreItems");
	loadMoreItems(".js-load_more_items");

	document.querySelectorAll(".js-outlined_read_more").forEach((btn) => {
		btn.addEventListener("click", () => {
			const item = btn.closest(".b-outlined_blocks-item");
			const isExpanded = item.classList.toggle("m-expanded");
			btn.setAttribute("aria-expanded", isExpanded ? "true" : "false");
		});
	});
});
